<template lang="pug">
  .employers-list-wrapper
    h2 {{ $wp('employer') }}

    label total de {{ $wp('employer') }}: {{ totalEmployers }}

    .button
      PButton(color="primary" size="md" @click="genReport") gerar relatório
      PButton(color="warning" size="md" @click="createNewEmployer") criar novo {{ $ws('employer') }}

    SmartTable.table(name="employer-list" v-bind="table", v-model="tableData" ref="table")
      template(v-slot:default="slotProps")
        TableRow(v-bind="slotProps")

          template(v-slot:name="{ columnValue }")
            span.no-wrap(:title="columnValue") {{ columnValue }}

          template(v-slot:tradingName="{ columnValue }")
            span.no-wrap(:title="columnValue") {{ columnValue }}

          template(v-slot:code="{ columnValue, rowItem, index }")
            span.no-wrap(:title="columnValue") {{ columnValue }}

          template(v-slot:cnpj="{ columnValue, rowItem, index }")
            | {{ columnValue | cnpj }}

          template(v-slot:cpf="{ columnValue, rowItem, index }")
            | {{ columnValue | cpf }}

      template(v-slot:detailsBox="{item}")
        .flex
          .name
            DBLabel(title="nome:", :body="item.name")

          DBLabel(title="cpf:", :body="item.cpf | cpf" v-if="item.cpf")
          DBLabel(title="cnpj:", :body="item.cnpj | cnpj" v-if="item.cnpj")
          DBLabel(:title="'nº de ' + $wp('employee') + ':'", :body="item.totalOfEmployees")

          .buttons
            PButton(color="info" size="md" @click="editEmployer(item.id)" title="editar")
              span.icon-ptt-icons-lapis

            PButton(color="danger" size="md" @click="deleteEmployer(item.id)" title="excluir")
              span.icon-ptt-icons-excluir

</template>

<script>
import { setAmplitudeEvent } from 'src/amplitudeUtils'
export default {
  name: 'EmployersList',
  mounted () {
    setAmplitudeEvent('lista empregador', {})
  },
  async created () {
    await this.$store.dispatch('common/employers/fetchItems')
  },
  data () {
    return {
      reloadingTable: false,
      table: {
        headerItems: [
          {column: 'razão social', field: 'name', width: '0.8fr'},
          {column: 'nome fantasia', field: 'tradingName', width: '0.6fr'},
          {column: 'código', field: 'code', width: '0.5fr'},
          {column: 'cpf', field: 'cpf', width: '0.6fr'},
          {column: 'cnpj', field: 'cnpj', width: '0.6fr'},
          {column: 'nº de ' + this.$wp('employee'), field: 'totalOfEmployees', width: '0.6fr'}
        ],
        config: {
          perPage: 15,
          startFocusedSearch: 'name',
          defaultSortField: 'name',
          defaultColumnSearch: 'name'
        }
      }
    }
  },
  computed: {
    totalEmployers () {
      return this.$store.state.common.employers.items.length
    },
    tableData: {
      get () {
        return {
          loading: this.reloadingTable || !this.$store.state.common.employers.items.length,
          loaded: this.$store.state.common.employers.items
        }
      }
    }
  },
  methods: {
    createNewEmployer () {
      this.$router.push('/employer/new')
    },
    editEmployer (employerId) {
      this.$router.push(`/employer/${employerId}`)
    },
    async deleteEmployer (employerId) {
      try {
        await this.$API.employer.delete({id: employerId})
        this.$swal({
          type: 'success',
          text: this.$ws('employer') + ' deletado com sucesso'
        })
        this.updateTable()
      } catch (e) {
        this.$swal({
          type: 'error',
          text: e.data.error || 'Não foi possível apagar o ' + this.$ws('employer')
        })
      }
    },
    async updateTable () {
      this.reloadingTable = true
      this.$refs.table.closeDetailsBox()
      await this.$store.dispatch('common/employers/fetchItems')
      this.reloadingTable = false
    },
    async genReport () {
      let result
      try {
        result = await this.$API.employerReport.get()
        this.$modalDeSucesso(result.data.success)
      } catch (e) {
        console.error(e)
        this.$modalDeErro(e?.data?.error ? e.data.error : 'Não foi possível gerar o relatório')
      }
    }
  },
  filters: {
    cnpj (v) {
      if (!v) return ''
      try {
        return `${v[0]}${v[1]}.${v[2]}${v[3]}${v[4]}.${v[5]}${v[6]}${v[7]}/${v[8]}${v[9]}${v[10]}${v[11]}-${v[12]}${v[13]}`
      } catch (e) {
        return ''
      }
    },
    cpf (v) {
      if (!v) return ''
      try {
        return `${v[0]}${v[1]}${v[2]}.${v[3]}${v[4]}${v[5]}.${v[6]}${v[7]}${v[8]}-${v[9]}${v[10]}`
      } catch (e) {
        return ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
.employers-list-wrapper {
  display: grid;
  grid-template-columns: 0.4fr 1fr;
  align-items: baseline;

  .button {
    grid-column: 2/3;
    justify-self: right;
    margin-bottom: var(--header-margin-bottom);
  }

  .flex {
    display: grid;
    grid-row-gap: 30px;
    grid-template-columns: 1fr 1fr 1fr;

    .name {
      grid-column: 1/4;
    }
    .buttons {
      grid-column: 1/4;
      justify-self: right;
      align-self: end;

      display: grid;
      grid-gap: 2px;
      grid-auto-flow: column;
    }
  }

  h2 {
    grid-column: 1/3;
    text-align: center;
  }
  .table {
    grid-column: 1/3;

    .loading-field {
      width: 30%;
      height: 60%;
      background-color: lightgray;
    }
  }
}
</style>
